export default __webpack_public_path__ + "static/media/EM0610.34I-22660_-15149_0.0f37ca2c.jpg";